import {
  FETCH_USERS_LIST,
  FETCH_USERINFO_INIT,
  FETCH_USERS_DETAIL,
  TOAST,
  UPDATE_USER,
  USER_ROLESDD,
  CREATE_USER,
  INIT_CREATE_USER_SCREEN,
  FETCH_LOCATIONS_DD,
  FETCH_COMPANIES_DD,
  USERS_SAVE_TABLE_STATE,
} from "../../../types/Systems/Users.type";

const formFieldValueMap = {
  id: null,
  username: "",
  status: "",
  alias: "",
  companyName: "",
  role: { id: null, title: "" },
  locations: [],
  companyAccess: [],
  creationTimestamp: "",
  modificationTimestamp: "",
  modifiedBy: "",
  ip: "",
};

const INITIAL_STATE = {
  userListView: [],
  LocationsDD: [],
  CompaniesDD: [],
  isLoading: false,
  error: null,
  formFieldValueMap,
  isUsersDetailSuccess: false,
  isUsersDetailError: false,
  isLocationDDSuccess: false,
  isLocationDDError: false,
  isCompaniesDDSuccess: false,
  isCompaniesDDError: false,
  isUserCreateSuccess: false,
  isUserCreateError: false,
  isUpdateUserSuccess: false,
  isUpdateUserError: false,
  isUserRolesDDSuccess: false,
  isUserRolesDDError: false,
  savedTableState: null,
};

const transformUserData = (content) => {
  const rows = content.map((user) => ({
    id: user.id,
    username: user.username,
    roleTitle: user.roles || user.roleTitle || "N/A",
    locationTitles: user.locationTitle || "N/A",
    alias: user.alias || "N/A",
    createdBy: user?.createdBy || "N/A",
    creationTimestamp: user?.creationTimestamp || "N/A",
    modificationTimestamp: user.modificationTimestamp || "N/A",
    modifiedBy: user.modifiedBy || "N/A",
    status: user.status || "N/A",
  }));

  const columns = [
    {
      colLabel: "Column Id",
      dataKey: "id",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: false,
        hidden: true,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Username",
      dataKey: "username",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
        sortField: "username",
      },
    },
    {
      colLabel: "Role",
      dataKey: "roleTitle",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
        sortField: "roleTitle",
      },
    },
    {
      colLabel: "Location",
      dataKey: "locationTitles",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Alias",
      dataKey: "alias",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Cart By",
      dataKey: "createdBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Cart Time",
      dataKey: "creationTimestamp",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Edit Time",
      dataKey: "modificationTimestamp",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Edit By",
      dataKey: "modifiedBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Status",
      dataKey: "status",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
  ];

  return { datas: { columns, rows } };
};

export const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_USERINFO_INIT:
      // Preserve savedTableState when reinitializing to restore filters on back navigation
      return { ...INITIAL_STATE, isLoadingPage: true, savedTableState: state.savedTableState };
    case FETCH_USERS_LIST.START:
    case FETCH_USERS_DETAIL.START:
    case UPDATE_USER.START:
    case USER_ROLESDD.START:
    case CREATE_USER.START:
    case FETCH_LOCATIONS_DD.START:
      return { ...state, isLoading: true };

    case INIT_CREATE_USER_SCREEN: {
      // Preserve savedTableState when navigating to create/edit screen
      return { ...INITIAL_STATE, savedTableState: state.savedTableState };
    }

    case CREATE_USER.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isUserCreateSuccess: true,
        isUserCreateError: false,
      };
    }
    case CREATE_USER.ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload?.message || action.payload?.error || "User creation failed",
        isUserCreateSuccess: false,
        isUserCreateError: true,
      };
    }
    case FETCH_USERS_LIST.SUCCESS: {
      const { page, data } = action.payload;

      let resetState = {
        userListView: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isCreateUserSuccess: false,
        isCreateUserError: false,
        // Preserve savedTableState
        savedTableState: state.savedTableState,
      };
      if (!data) {
        return resetState;
      }
      const { number, size, totalElements, totalPages } = page;
      const { datas } = transformUserData(data);
      return {
        ...resetState,
        userListView: datas,
        paginationInfo: {
          pageSize: size,
          totalRecords: totalElements,
          totalPages: totalPages,
          pageNumber: number,
        },
      };
    }

    case FETCH_USERS_LIST.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        userListView: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
      };
    }

    case FETCH_USERS_DETAIL.SUCCESS: {
      const payload = action.payload || {};

      const temp = { ...formFieldValueMap };
      Object.keys(temp).forEach((k) => {
        if (payload.hasOwnProperty(k)) temp[k] = payload[k];
      });

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isUsersDetailSuccess: true,
        isLocationDDSuccess: true,
        isLocationDDError: false,
      };
    }

    case FETCH_USERS_DETAIL.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error,
        isUsersDetailSuccess: false,
        isUsersDetailError: true,
        isLocationDDSuccess: false,
        isLocationDDError: true,
      };
    }

    case UPDATE_USER.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isUpdateUserSuccess: true,
        isUpdateUserError: false,
      };
    }

    case UPDATE_USER.ERROR: {
      const { error } = action?.payload;
      return {
        ...state,
        isLoading: false,
        isUpdateUserSuccess: false,
        isUpdateUserError: true,
        error: error || "Update failed",
      };
    }

    case USER_ROLESDD.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        UserRolesDD: temp,
        isUserRolesDDSuccess: true,
        isUserRolesDDError: false,
      };
    }
    case USER_ROLESDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isUserRolesDDSuccess: false,
        isUserRolesDDError: true,
      };
    }

    case FETCH_LOCATIONS_DD.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        LocationsDD: action.payload,
        isLocationsDDSuccess: true,
        isLocationsDDError: false,
      };
    }
    case FETCH_LOCATIONS_DD.ERROR: {
      return {
        ...state,
        isLoading: false,
        isLocationsDDSuccess: false,
        isLocationsDDError: true,
        error: action.payload?.error || "Failed to fetch locations",
      };
    }

    case FETCH_COMPANIES_DD.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        CompaniesDD: action.payload,
        isCompaniesDDSuccess: true,
        isCompaniesDDError: false,
      };
    }

    case FETCH_COMPANIES_DD.ERROR: {
      return {
        ...state,
        isLoading: false,
        isCompaniesDDSuccess: false,
        isCompaniesDDError: true,
        error: action.payload?.error || "Failed to fetch companies",
      };
    }

    case TOAST.RESET:
      return {
        ...state,
        isUserCreateSuccess: false,
        isUserCreateError: false,
        isUpdateUserSuccess: false,
        isUpdateUserError: false,
      };

    // Save table state (filters, pagination, sort) for restoration
    case USERS_SAVE_TABLE_STATE: {
      return {
        ...state,
        savedTableState: action.payload,
      };
    }

    default:
      return state;
  }
};
